import { CardHeader, styled, SxProps, Theme } from '@mui/material';

export const disabledSx: SxProps<Theme> = {
	pointerEvents: 'none',
	opacity: 0.5,
};

export const AccountSettingsTitle = styled('h3', { name: 'AccountSettingsTitle' })(({ theme }) => ({
	fontSize: theme.spacing(4),
	fontWeight: 600,
	marginTop: 0,
	marginBottom: theme.spacing(3),
	textAlign: 'left',
}));

export const CardHeaderWithActions = styled(CardHeader, { name: 'CardHeaderWithActions' })(
	({ theme }) => ({
		'.MuiCardHeader-action': {
			mt: 0,
			ml: theme.spacing(2),
			mr: 0,
		},
	})
);

export const AccountUserCard = styled('h3', { name: 'AccountSettingsTitle' })(({ theme }) => ({
	fontSize: theme.spacing(4),
	fontWeight: 600,
	marginTop: 0,
	marginBottom: theme.spacing(3),
	textAlign: 'left',
}));
